import React from 'react'
import {
  FormControl, Grid, TextField, Box, Button, Typography, Container, OutlinedInput, InputAdornment, Tooltip, Link
} from '@mui/material';
import { useForm } from 'react-hook-form';
import { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import axiosInstance from '../../../lib/axios';
import Flag from '../Booking/Flag';
import moment from 'moment';
import BokingCModal from './BokingCModal';
import { useReactToPrint } from 'react-to-print';
import BReport from '../../../atoms/ReportFolder/BReport';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import axiosInstanceForPG from '../../../lib/axiosFormPG';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import BillingDetailsModal from './ACCGenerateDetailsModal';
import CancelIcon from '@mui/icons-material/Cancel';


const columns = [
  { id: 'BookId', label: 'Book Id', minWidth: 100 },
  { id: 'BookNo', label: 'Booking No', minWidth: 120 },
  { id: 'BookDt', label: 'Book Date', minWidth: 130 },
  {
    id: 'BookSt',
    label: 'Status',
    minWidth: 130,
    // render: (value) => (
    //   <Typography
    //     sx={{
    //       color: value === 'C' ? 'green' : 'red',
    //       fontWeight: 'bold'
    //     }}
    //   >
    //     {value === 'C' ? 'Confirmed' : 'Unconfirmed'}
    //   </Typography>
    // )
  },
  { id: 'ResidentName', label: 'Resident Name', minWidth: 130 },
  { id: 'MobileNo', label: 'Mobile', minWidth: 150 },
  { id: 'Duration', label: 'Duration', minWidth: 100 },
  { id: 'BookDtFrom', label: 'Book From', minWidth: 100 },
  { id: 'BookUpToDt', label: 'Book To', minWidth: 100 },

];


function BookingConfirm(bookSt, onConfirm, bookId, onAccDetails, onAccGenerate) {
  const { register, watch, setValue, reset } = useForm();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [AccountGenerateRow, setAccountGenerateRow] = useState([]);
  const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
  const [OpenLoader, setOpenLoader] = useState(false);
  const location = useLocation();
  const [TransactionData, setTransactionData] = useState([]);
  const [OpenHistoryTableDialog, setOpenHistoryTableDialog] = useState(false);
  const [AccGenerate, setAccGenerate] = useState(false);
  const [BookId, setBookId] = useState(-1);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [searchTerms, setSearchTerms] = useState({});
  const [OpenAccountGDialog, setOpenAccountGDialog] = useState(false);
  const contentRef = useRef(null);
  const [switchState, setSwitchState] = useState(false);
  const [openBillingModal, setOpenBillingModal] = useState(false);
  const [billingDetails, setBillingDetails] = useState(null);
  const [isBookingConfirmed, setIsBookingConfirmed] = useState(false);
  const [isDepositPaid, setIsDepositPaid] = useState(false);
  const [PlanDataState, setPlanDataState] = useState(null);
  const [PayAdvice, setPayAdvice] = useState(null);
  const [PayGenerate, setPayGenerate] = useState(null);
  const [Mode, setMode] = useState('add');

  const IOSSwitch = styled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
  ))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 2,
      transitionDuration: '300ms',
      '&.Mui-checked': {
        transform: 'translateX(16px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: '#058302',
          opacity: 1,
          border: 0,
          ...theme.applyStyles('dark', {
            backgroundColor: '#635BFF',
          }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
          opacity: 0.5,
        },
      },
      '&.Mui-focusVisible .MuiSwitch-thumb': {
        color: '#33cf4d',
        border: '6px solid #fff',
      },
      '&.Mui-disabled .MuiSwitch-thumb': {
        color: theme.palette.grey[100],
        ...theme.applyStyles('dark', {
          color: theme.palette.grey[600],
        }),
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.7,
        ...theme.applyStyles('dark', {
          opacity: 0.3,
        }),
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: 22,
      height: 22,
    },
    '& .MuiSwitch-track': {
      borderRadius: 26 / 2,
      backgroundColor: '#E9E9EA',
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
      ...theme.applyStyles('dark', {
        backgroundColor: '#39393D',
      }),
    },
  }));

  const handlePrint = useReactToPrint({ contentRef });

  console.log("watch", watch());

  useEffect(() => {

    let MobileNo = location.state?.MobileNo.MobileNo;

    if (MobileNo) {
      handleMobileChange(MobileNo, "B");
    } else {
      setMode("add");
    }

    const fetchApi = async () => {
      setValue("CountryIcon", Flag);
      setValue("BookDt", "");
      setValue("BookDtFrom", "");
      setValue("BookUpToDt", "");
      await fetchDataOfBooking();
    };

    fetchApi();
  }, [location.state?.MobileNo]);

  useEffect(() => {

    if (TransactionData.length > 0) {
      const { MobileNo, ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, BookId, PropName, Email, PropId } = TransactionData[0];
      let obj = { ResidentName, BookNo, BookDt, Duration, BookDtFrom, BookUpToDt, TopupAmt, AdvcRcble, MobileNo, DiscAmt, TotalRent, NetAmt, BedRent, FreeMonth, PropName, Email, PropId }

      console.log("Transaction Obj", obj);
      setValue("MonthlyAmt", Math.round(NetAmt / Duration));
      setObjValue(obj);
      setValue("Email", Email);
      setValue("PropId", PropId);
      setBookId(BookId)
      const fetchDataAndSet = async () => {
        await fetchRoomBedData(TransactionData[0].RoomBedId, TransactionData[0].BookDtFrom, TransactionData[0].BookUpToDt, TransactionData[0].PropId);
        await fetchPlanData(TransactionData[0].RoomPlanId);
        await fetchServicesData(TransactionData[0].TransPlanId, TransactionData[0].MessPlanId);


      }
      fetchDataAndSet();
      setNetAmount();
    }

  }, [TransactionData]);

  useEffect(() => {
    if (AccountGenerateRow.length > 0) {
      setOpenAccountGDialog(true);
      handleLoaderClose();
    }

  }, [AccountGenerateRow])

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term) return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });
  }, [searchTerms, rows]);


  const fetchDataOfBooking = async () => {
    try {
      const response = await axiosInstance.post(
        `TrnBooking/GetTrnBookingDashBoard`,
        {
          "start": 0,
          "PageSize": 0,
          "SearchText":'' ,
          "Flag":"Bk",
          "MobileNo" :'',
          "BookNo":'',
          "PropId":1,
        }
      );

      if (response.data.Status === 0) {
        const formattedData = response.data.Data.map(bconfirm => ({
          ...bconfirm,
          BookSt: bconfirm.BookSt === "C" ? "Confirmed" : bconfirm.BookSt === "B" ? "Booked" : ""
        }));
        setRows(formattedData);
        // setRows(response.data.Data);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);
        setRows([]);
      }
    } catch (error) {
      console.error('Error fetching Booking data:', error);
    }
  };


  const handleDClickOnId = async (Id) => {
    try {
      const response = await axiosInstance.post(
        `TrnBooking/RetriveTrnBooking`,
        {
          "BookId": Id,
          "Flag": "R",
          CreatedBy:UserId
        }
      );

      if (response.data.Status === 0) {
        setTransactionData(response.data.Data);

      } else {
        console.error('Error fetching Grid data:', response.data.Message);
        toast.error("Error To Fetching The Data");
      }
    } catch (error) {
      console.error('Error fetching Booking data:', error);
    }
    handleClose();
  }


  const handleMobileChange = async (e, Separator) => {
    let val = "";
    if (Separator === "A") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }

    if (val.length >= 10) {
      try {
        const response = await axiosInstance.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": '',
            "Flag":'',
            "MobileNo" :val,
            "BookNo":'',
            "PropId":1,
          }
        );
        console.log("MobileRes", response)
        if (response.data.Status === 0) {
          const { BookSt, IsDepPaid } = response.data.Data[0];

          // Set deposit paid status
          setIsDepositPaid(IsDepPaid === "Y");

          // Set booking confirmation status based on BookSt
          setIsBookingConfirmed(BookSt === "C");
          setSwitchState(BookSt === "C");

          if (BookSt === "B") {
            setAccGenerate(false);
          } else {
            setAccGenerate(true);
          }

          setTransactionData(response.data.Data);
        } else {
          toast.info("Booking Doesn't Exist On This Number");
          resetFuncM();
          setValue("BookNo", "");
          setBookId(-1);
        }
      } catch (error) {
        console.error('Error fetching Booking data:', error);
      }
    } else if (val.length === 9) {
      resetFuncM();
      setValue("BookNo", "");
      setBookId(-1);
    }
    Separator === "B" && handleClose();
  };

  const handleBookNoChange = async (e, Separator) => {
    let val = "";
    if (Separator === "A") {
      val = e.target.value.trim()
    } else {
      val = e.trim();
    }
    if (val.length >= 8) {
      try {
        const response = await axiosInstance.post(
          `TrnBooking/GetTrnBookingDashBoard`,
          {
            "start": 1,
            "PageSize": 1,
            "SearchText": '',
            "Flag":'',
            "MobileNo" :'',
            "BookNo":val,
            "PropId":1,
          }
        );
        console.log("res", response);
        if (response.data.Status === 0) {
          const { BookSt, IsDepPaid } = response.data.Data[0];

          // Set deposit paid status
          setIsDepositPaid(IsDepPaid === "Y");

          // Set booking confirmation status based on BookSt
          setIsBookingConfirmed(BookSt === "C");
          setSwitchState(BookSt === "C");
          if (BookSt === "B") {
            setAccGenerate(true);

          } else {
            setAccGenerate(false);
          }
          setTransactionData(response.data.Data);
        } else {
          toast.info("Booking Doesn't Exist On This Number");
          resetFuncM();
          setValue("MobileNo", "");
          setBookId(-1);
        }
      } catch (error) {
        console.error('Error fetching Booking data:', error);
      }
    } else if (val.length === 7) {
      resetFuncM();
      setValue("MobileNo", "");
    }
    Separator === "B" && handleClose();
  }

  const fetchRoomBedData = async (RoomBedId, date1, date2, PropId) => {
    try {
      const response = await axiosInstance.post(`RoomBedMst/GetdrpRoomBedMst`, {
        BookFromDt: date1,
        BookToDt: date2,
        PropId: PropId,
        Flag: "",
        RoomBedId: RoomBedId
      });
      console.log("res", response);
      if (response.data.Status === 0) {
        handleRowDoubleClick(response.data.Data[0]);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);

      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  const fetchPlanData = async (PlanId) => {
    try {
      const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
        "RoomPlanID": PlanId,
        "Flag": "R"
      });

      if (response.data.Status === 0) {
        console.log("Plan Datares", response);
        setPlanData(response.data.Data);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);

      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  };

  // useEffect(() => {
  //   fetchPlanDataState();
  //   fetchPayAdvice();
  // }, []);

  const fetchPlanDataState = async (PlanId) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`MstRoomPlan/RetriveMstRoomPlan`, {
        "RoomPlanID": PlanId,
        "Flag": "R"
      });

      if (response.data.Status === 0) {
        console.log("PlanState Data", response);
        setPlanDataState(response.data.Data);
        setOpenBillingModal(true);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);

      }
    } catch (error) {
      console.error('Error fetching plan data:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchPayAdvice = async (Id) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "PytAdvDt": "2025-03-07",
        "Flag": "BookingWise",
        "BookId": Id
      });

      if (response.data.Status === 0) {
        console.log("PlanState Data", response);
        setPayAdvice(response.data.Data);
        setOpenBillingModal(true);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);

      }
    } catch (error) {
      console.error('Error fetching plan data:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const fetchPayGenerate = async (Id) => {
    try {
      setOpenLoader(true);
      const response = await axiosInstance.post(`TrnBooking/GetSelectTrnPytAdv`, {
        "PytAdvDt": "2025-02-26",
        "Flag": "GenPytAdv",
        "BookId": Id
      });

      if (response.data.Status === 0) {
        setPayGenerate(response.data.Data);
        setOpenBillingModal(true);
      } else {
        console.error('Error fetching Grid data:', response.data.Message);

      }
    } catch (error) {
      console.error('Error fetching pay generate data:', error);
    } finally {
      setOpenLoader(false);
    }
  };

  const handleRowDoubleClick = async (row) => {
    console.log('selected row', row);
    const { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, } = row;
    const obj = { WingName, FloorName, RoomTypeName, RoomViewNAme, RoomBedTypeName, RoombedName, };
    setObjValue(obj);
  };

  const setPlanData = (PlanArr) => {
    const { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt } = PlanArr[0];
    const obj = { PlanName, PlanTenur, LastAdjMonths, IncRentPerc, DepositAmt };
    setObjValue(obj);
  }


  const setObjValue = (obj) => {
    for (let key in obj) {
      setValue(key, obj[key]);
    }
  }

  const handleClose = () => {
    setOpenHistoryTableDialog(false);
    setPage(0);
    setTimeout(() => {
      setSearchTerms({});
    }, [500]);

  };

  const handleCloseAGDialog = () => {
    setOpenAccountGDialog(false);
  }

  const handleClickCheckAva = () => {
    setOpenHistoryTableDialog(true);
  }

  const setNetAmount = () => {
    setValue("TotalAmt", ((watch("TAmount") || 0) + (watch("MAmount") || 0) + (watch("TopupAmt") || 0) + (watch("AdvcRcble") || 0)));
  }



  const fetchServicesData = async (TransPlanId, MessPlanId) => {

    console.log("TransPlanId, MessPlanId", TransPlanId, MessPlanId);
    const Flag = "";
    try {
      const response = await axiosInstance.post(
        `MstTransPlan/getMstTransPlandrp`,
        { Flag, UserId },
      );
      console.log("property-data", response);
      if (response.data.Status === 0) {

        let obj = response.data.Data.find(obj => obj.TransPlanID === TransPlanId);
        if (obj) {
          console.log("Trans Amounr", obj.Amount)
          setValue("TAmount", obj.Amount);
        } else {
          setValue("TAmount", 0);
        }
        setNetAmount()

      } else {
        toast.error('Error fetching Trans data');
      }
    } catch (error) {
      toast.error('Error fetching property data');
    }

    try {
      const response = await axiosInstance.post(
        `MstMessPlan/getMstMessPlandrp`,
        { Flag, UserId },
      );
      console.log("property-data", response);
      if (response.data.Status === 0) {

        let obj = response.data.Data.find(obj => obj.MessPlanID === MessPlanId);
        if (obj) {
          console.log("Trans Amounr", obj.Amount)
          setValue("MAmount", obj.Amount);
        } else {
          setValue("MAmount", 0);
        }
        setNetAmount();

      } else {
      }
    } catch (error) {
      toast.error('Error fetching Plan data');
    }
  }

  const resetFuncM = async () => {

    const obj = {
      "ResidentName": "",
      "BookDt": "",
      "Duration": "",
      "BookDtFrom": "",
      "BookUpToDt": "",
      "WingName": "",
      "FloorName": "",
      "RoomTypeName": "",
      "RoombedName": "",
      "RoomBedTypeName": "",
      "BedRent": "",
      "PlanName": "",
      "PlanTenur": "",
      "FreeMonth": "0",
      "LastAdjMonths": "0",
      "IncRentPerc": "",
      "DepositAmt": "",
      "TopupAmt": "",
      "Tamt": "",
      "MAmount": "",
      "TAmount": "",
      "TotalRent": "",
      "DiscAmt": "",
      "NetAmt": "",
      "MonthlyAmt": "",
      "PropName": "",
      "TotalAmt": "",
      "AdvcRcble": ""
    }
    for (let key in obj) {
      setValue(key, "")
    }
    setValue("CountryIcon", Flag);

  };

  const handleSwitchChange = async (event) => {
    const isChecked = event.target.checked;

    if (!isChecked) {
      // Show confirmation dialog when trying to unconfirm
      const confirmUnconfirm = window.confirm("Are you sure you want to unconfirm this booking?");
      if (!confirmUnconfirm) {
        return; // Keep switch in current state if user cancels
      }
    }

    setSwitchState(isChecked);
    await handleClickConfirm();
  };


  const handleClickConfirm = async () => {
    if (BookId == -1) {
      toast.info("Transaction is Not Visible!!");
      return;
    }

    let Flag = switchState ? "B" : "C"; // Toggle between B and C based on current state

    try {
      const response = await axiosInstance.post(`TrnBooking/TrnBookingConfirmation`, {
        "BookId": TransactionData[0].BookId,
        "CreatedBy": UserId,
        Flag
      });

      if (response.data.Status === 0) {
        console.log("confirm res", response);
        toast.success(response.data.Message);
        Flag === "C" ? setAccGenerate(false) : setAccGenerate(true);
        setIsBookingConfirmed(Flag === "C");

        // Update the TransactionData to reflect new status
        setTransactionData(prevData => prevData.map(item => ({
          ...item,
          BookSt: Flag
        })));

      } else {
        console.error('Error fetching confirm data:', response.data.Message);
        // Revert switch state if API call fails
        setSwitchState(!switchState);
      }
    } catch (error) {
      console.error('Error fetching company data:', error);
      // Revert switch state if API call fails
      setSwitchState(!switchState);
    }
  };

  const handleAccountGenerateClick = async () => {
    if (BookId === -1) {
      toast.info("Transaction is Not Visible!!");
      return;
    }

    setOpenLoader(true);

    try {
      const response = await axiosInstance.post(
        `TrnBooking/AccountGenerateTrnBooking`,
        {
          "BookId": BookId,
          "CreatedBy": UserId,
          "AccountGenerate": "1",
          "IsAccGen": "",
          "IsDepPaid": isDepositPaid ? "Y" : "N"
        }
      );

      if (response.data.Status === 0) {
        // Fetch the account generate data
        try {
          const dataResponse = await axiosInstance.post(`BedCalendar/GetTrnBookingDtlwise`, {
            "Flag": "",
            "BookId": BookId
          });

          if (dataResponse.data.Status === 0) {
            const formattedData = dataResponse.data.Data.map(obj => {
              return { ...obj, PyadDt: moment(obj.PyadDt).format("MM-DD-YYYY") }
            });

            // Store data in session storage as a fallback
            sessionStorage.setItem('accountGenerateData', JSON.stringify(formattedData));

            // Navigate to the account generate table page with the data
            navigate('/accgeneratetable', {
              state: {
                accountData: formattedData,
                bookingInfo: {
                  residentName: watch("ResidentName"),
                  bookNo: watch("BookNo"),
                  mobileNo: watch("MobileNo")
                }
              }
            });
          } else {
            toast.error(dataResponse.data.Message || 'Error fetching account data');
          }
        } catch (error) {
          console.error('Error fetching account data:', error);
          toast.error('Error fetching account data');
        }
      } else {
        toast.error(response.data.Message || 'Error in account generation');
      }
    } catch (error) {
      toast.error('Error in account generation');
    } finally {
      setOpenLoader(false);
    }
  };

  const AccountGenerateData = async (Id) => {
    try {
      const response = await axiosInstance.post(`BedCalendar/GetTrnBookingDtlwise`, {
        "Flag": "",
        "BookId": Id
      });

      if (response.data.Status === 0) {
        console.log("confirm res", response);
        let data = response.data.Data.map(obj => {
          return { ...obj, PyadDt: moment(obj.PyadDt).format("MM-DD-YYYY") }
        });

        setAccountGenerateRow(data);
      } else {
        console.error('Error fetching confirm data:', response.data.Message);

      }
    } catch (error) {
      console.error('Error fetching company data:', error);
    }
  }

  const generatePDFContent = () => {
    try {
      const doc = new jsPDF();

      // Set initial y position
      let yPos = 20;
      const pageWidth = doc.internal.pageSize.width;
      const margin = 20;
      const contentWidth = pageWidth - (2 * margin);

      // Header Section
      doc.setTextColor(99, 91, 255); // #635bff
      doc.setFontSize(20);
      doc.text('Clanbridge Living Pvt Ltd', pageWidth / 2, yPos, { align: 'center' });

      yPos += 10;
      doc.setFontSize(18);
      doc.setTextColor(0);
      doc.text('Booking Confirmation', pageWidth / 2, yPos, { align: 'center' });

      // Booking Summary Section
      yPos += 15;
      doc.autoTable({
        startY: yPos,
        head: [
          [{ content: 'Booking Summary', colSpan: 4, styles: { halign: 'center', fillColor: [99, 91, 255], textColor: 255 } }]
        ],
        body: [
          [
            { content: 'Booking No', styles: { fontStyle: 'bold' } },
            watch('BookNo') || '',
            { content: 'Book Date', styles: { fontStyle: 'bold' } },
            moment(watch('BookDt')).format('DD-MM-YYYY')
          ],
          [
            { content: 'Mobile', styles: { fontStyle: 'bold' } },
            watch('MobileNo') || '',
            { content: 'Email', styles: { fontStyle: 'bold' } },
            watch('Email') || ''
          ],
          [
            { content: 'From Date', styles: { fontStyle: 'bold' } },
            moment(watch('BookDtFrom')).format('DD-MM-YYYY'),
            { content: 'To Date', styles: { fontStyle: 'bold' } },
            moment(watch('BookUpToDt')).format('DD-MM-YYYY')
          ],
          [
            { content: 'Duration', styles: { fontStyle: 'bold' } },
            watch('Duration') || '',
            { content: 'Property Name', styles: { fontStyle: 'bold' } },
            watch('PropName') || ''
          ],
          [
            { content: 'Resident Name', styles: { fontStyle: 'bold' } },
            { content: watch('ResidentName') || '', colSpan: 3 }
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });

      // Room Details Section
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Room Details', margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        body: [
          [
            { content: 'Wing', styles: { fontStyle: 'bold' } },
            watch('WingName') || '',
            { content: 'Floor', styles: { fontStyle: 'bold' } },
            watch('FloorName') || '',
            { content: 'Room Type', styles: { fontStyle: 'bold' } },
            watch('RoomTypeName') || ''
          ],
          [
            { content: 'Bed No', styles: { fontStyle: 'bold' } },
            watch('RoombedName') || '',
            { content: 'Bed Type', styles: { fontStyle: 'bold' } },
            watch('RoomBedTypeName') || '',
            { content: 'Standard Rent', styles: { fontStyle: 'bold' } },
            watch('BedRent') || ''
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });

      // Plan Details Section
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Plan Details', margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        body: [
          [
            { content: 'Plan', styles: { fontStyle: 'bold' } },
            watch('PlanName') || '',
            { content: 'Duration', styles: { fontStyle: 'bold' } },
            watch('Duration') || ''
          ],
          [
            { content: 'Free Months', styles: { fontStyle: 'bold' } },
            watch('FreeMonth') || '0',
            { content: 'Min Adv Month', styles: { fontStyle: 'bold' } },
            watch('LastAdjMonths') || '0'
          ],
          [
            { content: 'Increment %', styles: { fontStyle: 'bold' } },
            watch('IncRentPerc') || '0',
            { content: 'Deposit', styles: { fontStyle: 'bold' } },
            watch('DepositAmt') || ''
          ],
          [
            { content: 'Total Rent', styles: { fontStyle: 'bold' } },
            watch('TotalRent') || '',
            { content: 'Discount', styles: { fontStyle: 'bold' } },
            watch('DiscAmt') || ''
          ],
          [
            { content: 'Net Amount', styles: { fontStyle: 'bold' } },
            watch('NetAmt') || '',
            { content: 'Monthly Amount', styles: { fontStyle: 'bold' } },
            watch('MonthlyAmt') || ''
          ],
          [
            { content: 'Net Payable', styles: { fontStyle: 'bold' } },
            watch('AdvcRcble') || '',
            { content: '', styles: { fontStyle: 'bold' } },
            ''
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });

      // Other Services Section
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(16);
      doc.setTextColor(99, 91, 255);
      doc.text('Other Services', margin, yPos);

      doc.autoTable({
        startY: yPos + 5,
        body: [
          [
            { content: 'Topup Amount', styles: { fontStyle: 'bold' } },
            watch('TopupAmt') || '',
            { content: 'Transport Service', styles: { fontStyle: 'bold' } },
            watch('TAmount') || ''
          ],
          [
            { content: 'Mess Service', styles: { fontStyle: 'bold' } },
            watch('MAmount') || '',
            { content: 'Total Amount', styles: { fontStyle: 'bold' } },
            watch('TotalAmt') || ''
          ]
        ],
        theme: 'grid',
        styles: {
          fontSize: 10,
          cellPadding: 2.3,
          lineColor: [229, 231, 235],
          lineWidth: 0.1
        },
        alternateRowStyles: {
          fillColor: [249, 250, 251]
        },
        margin: { left: margin, right: margin }
      });

      // Footer
      yPos = doc.lastAutoTable.finalY + 15;
      doc.setFontSize(12);
      doc.setTextColor(0);
      doc.text('Thank you for choosing Clanbridge Living Pvt Ltd', margin, yPos);
      doc.text('For any queries, please contact: support@clanbridgeliving.in', margin, yPos + 5);

      return doc;
    } catch (error) {
      console.error('Error generating PDF:', error);
      return null;
    }
  };


  const handleEmailSentLink = async () => {
    setOpenLoader(true);
    const userEmail = watch("Email");
    const propId = parseInt(watch("PropId"));
    const userId = parseInt(UserId);

    if (!userEmail) {
      toast.error("Email address not available");
      setOpenLoader(false);
      return;
    }

    try {
      // Generate PDF
      const doc = generatePDFContent();
      if (!doc) {
        toast.error("Failed to generate PDF document");
        setOpenLoader(false);
        return;
      }

      // Convert PDF to base64
      const pdfData = doc.output();
      const pdfBase64 = btoa(pdfData);
      const pdfDataUri = `data:application/pdf;base64,${pdfBase64}`;

      // Format dates for email
      const startDate = moment(watch('BookDtFrom')).format('DD MMM YYYY');
      const endDate = moment(watch('BookUpToDt')).format('DD MMM YYYY');

      // Create email subject and body
      const Subject = `Resident Booking Confirmation - ${watch("BookNo")} - ${watch("ResidentName")}`;
      const Body = `
      Dear ${watch("ResidentName")},<br><br>
      
      I hope you are doing well.<br><br>
      
      We are pleased to confirm your booking for ${watch("PropName")} has been successfully processed. 
      Please find attached the relevant booking details for your reference.<br><br>
      
      Here are the key details of your booking:<br>
      • <strong>Booking No</strong>: ${watch("BookNo")}<br>
      • <strong>Booking Dates</strong>: ${startDate} to ${endDate}<br>
      • <strong>Property</strong>: ${watch("PropName")}<br>
     
      For your convenience, we have attached the booking confirmation document for your records. 
      If you have any questions or need further assistance, please feel free to reach out to us.<br><br>
      
      Thank you for choosing Clanbridge Living Pvt Ltd. We look forward to welcoming you.<br><br>
      
      Best regards,<br>
      Clanbridge Living Pvt Ltd<br>
      Email: support@clanbridgeliving.in<br>
      Contact: +91 XXX XXX XXXX
    `;

      const emailRequest = {
        ToEmail: userEmail ? [userEmail] : [],
        Subject,
        Body,
        ImgFolderNm: watch("BookNo"),
        DocAttachments: [{
          FileName: `Booking_${watch("BookNo")}.pdf`,
          FileContent: pdfDataUri
        }],
        PropId: propId,
        UserId: userId,
      };

      const response = await axiosInstanceForPG.post(
        `EmailRequest/SendEmail`,
        emailRequest
      );

      if (response.data.Status === 0) {
        toast.success("Email sent successfully");
      } else {
        toast.error(response.data.Message || "Failed to send email");
      }
    } catch (error) {
      console.error('Error in email process:', error);
      toast.error(`Failed to send email: ${error.message}`);
    } finally {
      setOpenLoader(false);
    }
  };

  const handleClickCancel = () => {
    navigate("/BookingConfirmTable");
  }

  const handleLoaderClose = () => {
    setOpenLoader(false);
  }

  const handleBillingDetails = async () => {
    if (BookId === -1) {
      toast.info("No transaction is visible");
      return;
    }

    try {
      setOpenLoader(true); // Show loader while fetching
      const response = await axiosInstance.post(
        'TrnBooking/GetReportTrnBooking',
        {
          "BookId": BookId,
          "Flag": "R"
        }
      );

      console.log("API Response:", response.data); // Add this for debugging

      if (response.data.Status === 0 && response.data.Data) {
        setBillingDetails(response.data.Data);
        setOpenBillingModal(true);

        await fetchPlanDataState(TransactionData[0].RoomPlanId);
        await fetchPayAdvice(BookId);
        await fetchPayGenerate(BookId);
      } else {
        toast.error('No billing details found');
      }
    } catch (error) {
      console.error('Error fetching billing details:', error);
      toast.error('Error fetching billing details');
    } finally {
      setOpenLoader(false); // Hide loader
    }
  };

  const handleClick = () => {
    navigate('/accgeneratetable');
  };

  const MonthlyPayment = watch('MonthlyAmt') || 0;
  const FreePay = watch('FreeMonth') || 0;

  useEffect(() => {
    const discount = MonthlyPayment * FreePay;
    setValue('discount', discount);
  }, [MonthlyPayment, FreePay, setValue]);

  return (
    <Box className="form-container">
      <Backdrop
        sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1, display: "flex", gap: 1 })}
        open={OpenLoader}
        onClick={handleLoaderClose}
      >
        <CircularProgress color="inherit" />
        <Typography >
          Display Statement
        </Typography>

      </Backdrop>
      <ToastContainer />

      <BokingCModal OpenHistoryTableDialog={OpenHistoryTableDialog} handleClose={handleClose} columns={columns} TextField={TextField} handleSearchChange={handleSearchChange} filteredRows={filteredRows} page={page} rowsPerPage={rowsPerPage} handleBookNoChange={handleBookNoChange} handleMobileChange={handleMobileChange} handleChangePage={handleChangePage} handleChangeRowsPerPage={handleChangeRowsPerPage} />

      <BillingDetailsModal open={openBillingModal} onClose={() => setOpenBillingModal(false)}
        billingData={billingDetails} planData={PlanDataState} payAdvice={PayAdvice}
        payGenerate={PayGenerate}
      />
      <Grid container spacing={3} className="rasidant_grid"  >

        <Container maxWidth="lg" spacing={1} justifyContent="center" alignItems="center" >
          <Typography variant="h5" gutterBottom align="center">
            Booking Confirmation
          </Typography>

          <Grid container md={12} spacing={0.5}>
            <Grid item xs={12} md={4}>
              <FormControl variant="outlined" fullWidth>
                <OutlinedInput
                  id="outlined-adornment-weight"
                  startAdornment={
                    <InputAdornment position="start">
                      <div
                        style={{
                          width: 25,
                          height: 15,
                          backgroundImage: `url(${watch("CountryIcon")})`,
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          borderRadius: '4px',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                        }}
                      />
                    </InputAdornment>
                  }
                  aria-describedby="outlined-weight-helper-text"
                  placeholder={`Enter Valid  Mobile Number`}
                  style={{ width: "100%", height: 40 }}

                  value={watch('MobileNo') || ''}
                  {...register('MobileNo', { onChange: (e) => handleMobileChange(e, 'A') })}
                  inputProps={{
                    'aria-label': 'weight',
                    style: { height: 40 },
                  }}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                id="PropName"
                name="PropName"
                label="Property Name"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('PropName') || ''}
                {...register('PropName')}
                InputProps={{
                  readOnly: true,
                }}

              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField
                id="ResidentName"
                name="ResidentName"
                label="First Name"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('ResidentName') || ''}
                {...register('ResidentName')}
                InputProps={{
                  readOnly: true,
                }}

              />
            </Grid>

            <Grid item xs={12} md={2}>
              <TextField
                id="BookNo"
                name="BookNo"
                label="Book No"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('BookNo') || ''}
                {...register('BookNo', { onChange: (e) => handleBookNoChange(e, 'A') })}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                id="BookDt"
                name="BookDt"
                label="Book Date"
                variant="filled"
                type="date"
                fullWidth
                className="custom-textfield"
                value={moment(watch('BookDt')).format("YYYY-MM-DD")}
                {...register('BookDt')}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                id="Duration"
                name="Duration"
                label="Duration"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={watch('Duration') || ''}
                {...register('Duration')}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                id="BookDtFrom"
                name="BookDtFrom"
                type="date"
                label="Book From Date"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={moment(watch('BookDtFrom')).format("YYYY-MM-DD")}
                {...register('BookDtFrom')}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} md={2}>
              <TextField
                id="BookUpToDt"
                name="BookUpToDt"
                label="Book To Date"
                type="date"
                variant="filled"
                fullWidth
                className="custom-textfield"
                value={moment(watch('BookUpToDt')).format("YYYY-MM-DD")}
                {...register('BookUpToDt')}
                InputProps={{
                  readOnly: true,
                }}

              />
            </Grid>
            <Grid item xs={12} md={2} sx={{ display: "flex", justifyContent: 'flex-start', alignItems: 'center' }} >
              <Button
                variant="contained"
                size="medium"
                sx={{
                  backgroundColor: "#635bff",
                  height: 35,
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                }}
                onClick={handleClickCheckAva}
              >
                Get Data
              </Button>
            </Grid>

          </Grid>

          <hr></hr>

          <Grid container spacing={1}>
            <Grid item xs={12} sm={2}>

              <Typography variant="h6" gutterBottom >
                Room Details
              </Typography>

            </Grid>

            {/* Work Info Column */}
            <Grid item xs={12} sm={10}>
              <Grid container spacing={1} >
                <Grid item xs={12} md={4}>
                  <TextField
                    id="WingName"
                    name="WingName"
                    label="Wing"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={watch('WingName') || ''}
                    {...register('WingName')}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    id="FloorName"
                    name="FloorName"
                    label="Floor"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={watch('FloorName') || ''}
                    {...register('FloorName')}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="RoomTypeName"
                    name="RoomTypeName"
                    label="Room Type"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={watch('RoomTypeName') || ''}
                    {...register('RoomTypeName')}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="RoombedName"
                    name="RoombedName"
                    label="Bed No"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={watch('RoombedName') || ''}
                    {...register('RoombedName')}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="RoomBedTypeName"
                    name="RoomBedTypeName"
                    label="Bed Type"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    value={watch('RoomBedTypeName') || ''}
                    {...register('RoomBedTypeName')}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    id="BedRent"
                    name="BedRent"
                    label="Standard Rent"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('BedRent')}
                    value={watch('BedRent') || ''}
                    InputProps={{
                      readOnly: true,
                    }}

                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <hr></hr>

          <Grid container spacing={0.5}>
            <Grid item xs={12} sm={2}>

              <Typography variant="h6" gutterBottom >
                Plan Details
              </Typography>

            </Grid>

            {/* Work Info Column */}
            <Grid item xs={12} sm={10}>
              <Grid container spacing={1} >
                <Grid item xs={12} md={2}>
                  <TextField
                    id="PlanName"
                    name="PlanName"
                    label="Plan"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('PlanName')}
                    value={watch('PlanName') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="PlanTenur"
                    name="PlanTenur"
                    label="Tenur"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('PlanTenur')}
                    value={watch('PlanTenur') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="FreeMonth"
                    name="FreeMonth"
                    label="Free month"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('FreeMonth')}
                    value={watch('FreeMonth') || 0}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="LastAdjMonths"
                    name="LastAdjMonths"
                    label="Min Adv Month"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('LastAdjMonths')}
                    value={watch('LastAdjMonths') || 0}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="IncRentPerc"
                    name="IncRentPerc"
                    label="Increment %"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('IncRentPerc')}
                    value={watch('IncRentPerc') || 0}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="DepositAmt"
                    name="DepositAmt"
                    label="Deposit"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('DepositAmt')}
                    value={watch('DepositAmt') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="TotalRent"
                    name="TotalRent"
                    label="Total Rent"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('TotalRent')}
                    value={watch('TotalRent') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <TextField
                    id="DiscAmt"
                    name="DiscAmt"
                    label="Coupon Discount"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('DiscAmt')}
                    value={watch('DiscAmt') || 0}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="discount"
                    name="discount"
                    label="Discount"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('discount')}
                    value={watch('discount') || 0}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="NetAmt"
                    name="NetAmt"
                    label="Net Amount"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('NetAmt')}
                    value={watch('NetAmt') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="MonthlyAmt"
                    name="MonthlyAmt"
                    label="Effective Rent"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('MonthlyAmt')}
                    value={watch('MonthlyAmt') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={2}>
                  <TextField
                    id="AdvcRcble"
                    name="AdvcRcble"
                    label="Net Payable"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('AdvcRcble')}
                    value={watch('AdvcRcble') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

              </Grid>
              {/* </Paper> */}
            </Grid>

          </Grid>
          <Grid container spacing={1} sx={{ marginTop: "1px" }}>
            <Grid item xs={12} sm={2}>

              <Typography variant="h6" gutterBottom >
                Other Service
              </Typography>

            </Grid>

            {/* Work Info Column */}
            <Grid item xs={12} sm={10} >
              <Grid container spacing={1}  >

                <Grid item xs={12} md={4}>
                  <TextField
                    id="TopupAmt"
                    name="TopupAmt"
                    label="Topup Amount"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('TopupAmt')}
                    value={watch('TopupAmt') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    id="TAmount"
                    name="TAmount"
                    label="Transport Service"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('TAmount')}
                    value={watch('TAmount') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="MAmount"
                    name="MAmount"
                    label="Mess Service"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('MAmount')}
                    value={watch('MAmount') || ''}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={1} sx={{ marginTop: "1px" }}>
            <Grid item xs={6} sm={2}>

              <Typography variant="h6" gutterBottom >
                Deposit :
              </Typography>

            </Grid>

            {/* Work Info Column */}
            <Grid item xs={6} sm={10} >
              <Grid container spacing={1}   >
                <Grid item xs={12} md={4} display={"flex"} alignItems={"center"} gap={"10px"}>
                  <Typography variant="h6" gutterBottom sx={{ color: isDepositPaid ? "green" : "red" }}>
                    {isDepositPaid ? "Paid" : "Unpaid"}
                  </Typography>
                  <Typography>
                    {isDepositPaid ? (
                      <CheckCircleIcon sx={{ color: 'green' }} />
                    ) : (
                      <CancelIcon sx={{ color: 'red' }} />
                    )}
                  </Typography>

                </Grid>
                <Grid item xs={12} md={4} sx={{
                  textAlign: {
                    xs: 'center',
                    md: 'right'
                  }
                }}>
                  <Typography variant="h6" align="right" sx={{ marginBottom: 0 }}>
                    Total Amount :
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    id="TotalAmt"
                    name="TotalAmt"
                    label="TotalAmt"
                    variant="filled"
                    fullWidth
                    className="custom-textfield"
                    {...register('TotalAmt')}
                    value={watch('TotalAmt') || 0.00}
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>
              </Grid>

            </Grid>

          </Grid>

          <Grid container spacing={1} sx={{ marginTop: "1px" }}>
            <Grid item xs={6} sm={2}>
              <Typography
                variant="h6"
                sx={{
                  color: isBookingConfirmed ? 'green' : 'red',
                  fontWeight: 'bold',
                  marginBottom: "3px"
                }}
              >
                {isBookingConfirmed ? 'Confirmed' : 'Unconfirmed'}
              </Typography>
              {/* <Typography variant="caption" color="textSecondary">
                * Toggle switch to change status
              </Typography> */}
            </Grid>

            <Grid item xs={6} sm={10} >
              <Grid container spacing={0}   >
                <Grid item xs={12} md={8} display={"flex"} alignItems={"center"} gap={"10px"}>
                  <FormControlLabel
                    control={
                      <IOSSwitch
                        sx={{ m: 1 }}
                        checked={switchState}
                        onChange={handleSwitchChange}
                        // disabled={!isDepositPaid || BookId === -1}
                        disabled={true}
                      />
                    }
                  />
                </Grid>

                <Grid item xs={12} md={4} display="flex" alignItems="center" gap={2}>
                  {/* <Link
                    component="button"
                    onClick={handleEmailSentLink}  
                    sx={{ cursor: 'pointer', textDecoration: 'none' }}
                  >
                    Send Payment Link
                  </Link> */}

                  <Link
                    component="button"
                    onClick={handleEmailSentLink}
                    sx={{ cursor: 'pointer', textDecoration: 'none' }}
                  >
                    Send mail
                  </Link>
                </Grid>

                <Grid item xs={12} md={5}>  </Grid>

                <Grid item xs={12} md={7} sx={{ display: 'flex', justifyContent: 'end' }}>
                  <Tooltip title="View Billing Details">
                    <span>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#635bff",
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          marginX: 0.2
                        }}
                        onClick={handleBillingDetails}
                        disabled={BookId === -1 || !isBookingConfirmed} // Enable only if booking is confirmed
                      >
                        Acc Details
                      </Button>
                    </span>
                  </Tooltip>

                  <Tooltip>
                    <span>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          backgroundColor: "#635bff",
                          whiteSpace: 'nowrap',
                          textOverflow: 'ellipsis',
                          overflow: 'hidden',
                          marginX: 0.2
                        }}
                        onClick={handleAccountGenerateClick}
                        disabled={BookId === -1 || !isBookingConfirmed}
                      >
                        Acc Gen
                      </Button>
                    </span>
                  </Tooltip>

                  <Tooltip >
                    <span>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ backgroundColor: '#635BFF', marginX: 0.2 }}
                        onClick={handlePrint}
                        disabled={BookId == -1 ? true : false}
                      >
                        Print
                      </Button>
                    </span>
                  </Tooltip>

                  <Tooltip >
                    <span>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ backgroundColor: '#635BFF', marginX: 0.2 }}
                        onClick={handleClickCancel}
                      >
                        Cancel
                      </Button>
                    </span>
                  </Tooltip>
                </Grid>

              </Grid>

            </Grid>
          </Grid>

        </Container>
        <div style={{ display: 'none' }}>
          {<BReport contentRef={contentRef} DataObj={watch()} />}
        </div>
      </Grid>

    </Box >
  )
}

export default BookingConfirm;